import environment from "../../environment";

let host = "";

if (environment.name === "production") {
  host = "https://us-central1-fansaves-d0d9e.cloudfunctions.net";
} else if (environment.name === "staging") {
  host = "https://us-central1-fansaves-staging.cloudfunctions.net";

  if (
    environment.useFirebaseEmulators &&
    window.location.hostname === "localhost"
  ) {
    host = "http://localhost:5001/fansaves-staging/us-central1";
  }
} else {
  console.error(`Unknown environment: ${environment.name}`);
  throw new Error(
    `Invalid environment configuration: ${environment.name}. Must be 'staging' or 'production'.`
  );
}

export default host;
